"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../util");
var CardHeader = function CardHeader(_ref) {
  var title = _ref.title,
    index = _ref.index,
    subheader1 = _ref.subheader1,
    subheader2 = _ref.subheader2;
  var bem = (0, _util.bemClass)('revision-offers');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: bem('card-header')
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: bem('card-header', 'card-heading')
  }, title, /*#__PURE__*/_react.default.createElement("sup", null, index)), /*#__PURE__*/_react.default.createElement("h4", {
    className: bem('card-header', 'card-subheading')
  }, /*#__PURE__*/_react.default.createElement("p", null, subheader1), /*#__PURE__*/_react.default.createElement("p", null, subheader2)));
};
CardHeader.propTypes = {
  title: _propTypes.default.string.isRequired,
  index: _propTypes.default.number.isRequired,
  subheader1: _propTypes.default.string.isRequired,
  subheader2: _propTypes.default.string.isRequired
};
var _default = exports.default = CardHeader;
